export default {
      id: "icon-my-hallam-usage",
      viewBox: "0 0 23.608 23.608",
      url: __webpack_public_path__ + "img/icons.svg#icon-my-hallam",
      toString: function () {
        return this.url;
      }
    }